import React from 'react';
import cls from "./pairs.module.scss"
import { Link } from '../../../helper/Link';
import { useTranslation } from 'react-i18next';
import AdvantagesFirst from "../../../assets/advantages/AdvantagesFirst.svg"

const Pairs = () => {
  const { t } = useTranslation()
  return (
    <div className={cls.pairs_container}>
      <div className={cls.main_block}>
        <div className={cls.icon_main}>
          <div className={cls.pairs_item}>
            <img src={AdvantagesFirst} alt='' />
          </div>
          <div className={cls.links}>
            <p className={cls.main_text_2}>{t('main_text_23')}</p>
            <p className={cls.main_text_3}>{t('main_text_24')}</p>
          </div>
          <Link to="/driver" className={cls.main_btn}>
            {t('partner_btn')}
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Pairs;